<script>
import store from "@/state/store";
import Vue2Dropzone from "vue2-dropzone";
import apiEndpoints from "@/services/apiEndpoints";
import files from '@/mixins/files';

export default {
  mixins: [files],
  components: {
    VueDropzone: Vue2Dropzone
  },
  data() {
    return {
      isLoading: false,
      dropzoneOptions: {
        headers: {"Authorization": 'Bearer ' + store.getters['auth/token']},
        acceptedFiles: '.csv',
        addRemoveLinks: true,
        dictRemoveFile: "消去",
        dictFileTooBig: "ファイルのサイズは無効です。",
        dictInvalidFileType: "ファイルのフォーマットが無効です。",
        dictCancelUpload: "消去",
        previewTemplate: this.template(),
        maxFiles: 1
      },
      disableUpload: false,
      disableSubmit: true,
      isErrorFile: false,
      apiURl: process.env.VUE_APP_API_URL + '/api',
    };
  },
  created() {
    const url = this.apiURl + apiEndpoints.calendar_setting_upload;
    this.dropzoneOptions.url = url;
  },
  methods: {
    template() {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-details">
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
            </div>
        `;
    },
    fileAdded() {
      this.disableUpload = true
      this.disableSubmit = false
      this.isLoading = true;
    },
    fileRemoved() {
      this.disableUpload = false
      this.isErrorFile = false;
    },
    fileError() {
      this.isErrorFile = true
      this.disableSubmit = true
      this.isLoading = false;
    },
    uploadSuccess(file, response) {
      let result = response.result[0]
      let that = this;
      if (result) {
        this.$swal({
          text: "CSV のアップロードに成功しました。",
          type: "success"
        }).then(function () {
            that.$router.push({path: that.$route.fullPath, query: {refresh: new Date().getTime()}});
          }
        );
      }
      this.isErrorFile = !result
      this.isLoading = false;
    },
    async downloadTemplate(){
      try {
        this.idLoadExportExcel = true;
        const response = await this.$http.get(apiEndpoints.calendar_template)

        if (response?.status) {
          this.downloadFile(response, 'calendar_template', 'csv')
          this.successToast("テンプレートファイルをダウンロードしました", false, 2000);
        } else {
          this.errorToast("テンプレートファイルのダウンロードに失敗しました", false, 2000);
        }

        this.idLoadExportExcel = false;
      } catch (error) {
        console.log(error);
        this.errorToast("テンプレートファイルのダウンロードに失敗しました", false, 2000);
        this.idLoadExportExcel = false;
      }
    }
  }
};
</script>
<template>
  <div>
    <b-overlay
      :show="isLoading"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
    >
      <div class="mt-5 gap-4 align-items-center">
        <div>
          <div class="mb-2 d-xl-flex drop-calendar">
            <vue-dropzone
              :options="dropzoneOptions"
              :include-styling="false"
              :useCustomSlot=true
              @vdropzone-file-added="fileAdded"
              @vdropzone-removed-file="fileRemoved"
              @vdropzone-error="fileError"
              ref="calendarCsvUploadDropzone"
              @vdropzone-success="uploadSuccess"
              id="calendar-setting-upload">
              <button
                class="btn btn-primary w-md"
                :disabled="disableUpload"
              >
              <i class="fas fa-calendar-alt"></i>
                CSVファイルをアップロードする
              </button>
            </vue-dropzone>
          </div>
          <p class="text-danger text-center" v-if="isErrorFile">
            取込に失敗しました。CSVファイルを確認してください。
          </p>

          <div>
          <button
                class="btn btn-primary w-md m-left"
                @click="downloadTemplate"
              >
              <i class="fas fa-calendar-alt m-left"></i>
                テンプレートダウンロード
          </button>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<style lang="scss">
.drop-calendar {
  .vue-dropzone {
    background-color: #f6f6f6;
    border: none !important;
    min-height: 0 !important;
    padding: 0 !important;
    margin-left: 20px;

    .dz-message {
      margin: 0 !important;
    }
  }

  .dz-remove, .dz-error-message {
    color: red;
  }

  #calendar-setting-upload {
    margin-bottom: 20px;
    width: 100%;
    .dz-message {
      width: 100%;
    }
  }

  .dz-preview {
    margin-top: 10px;
    margin-left: 10px;
    display: inline-flex;
  }

  .dz-max-files-reached {
    pointer-events: none;
    cursor: default;
  }

  .dz-remove {
    pointer-events: all;
    cursor: pointer;
    border: 1px solid red;
    margin-left: 10px;
    height: 28px;
    border-radius: 3px;
    padding: 2px;
    background: #ff000017;
  }

  .m-left{
    margin-left: 5px;
  }
}
</style>
